import styled from 'styled-components'
import { Page as PageRef } from '../../components/layouts'

export const Page = styled(PageRef)`
  max-width: 100%;
  /*min-height: 95.4vh;*/
  min-height: 100vh;
`
